import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetCategoryPatch } from '@/Module/Grade/Model/ApiModel';
import type { ICategoryPath } from '@/Module/Grade/Model/DataModel';
import { CategoryService } from '@/Module/Grade/Service';

export const getCategoryCategoryListAction = createAsyncThunk<ICategoryPath[], IGetCategoryPatch>(
  'category/getCategoryCategoryList',
  (req, { signal }) => {
    return CategoryService.getList({ ...req }, signal).then(({ data: { data } }) => data);
  },
);
